export const throwIf = (cond: boolean, message: string, ErrorClass = Error) => {
  if (cond) {
    throw ErrorClass(`Expected ${message}`);
  }
};
